import get from 'lodash/get';

import { Box, Typography } from '@sbv-clients/ui-shared';

import { useAdminFacilityIdGet } from '../../services/admin';
import EmployeeDuplicateUsersGrid from './employee-duplicate-users-grid/facility-users-grid';

export const ListEmployeeDuplicateUsersPage = ({
  facilityName,
}: {
  facilityName: string;
}) => {
  return (
    <Box
      height="100%"
      display="grid"
      gridTemplateRows="auto 1fr auto"
      p={2}
      rowGap={2}
    >
      <Typography variant="h4">{facilityName || '-'}</Typography>
      <EmployeeDuplicateUsersGrid databaseName={facilityName} />
    </Box>
  );
};
